<template>
  <div>
    <v-row>
      <v-col md="3" v-for="image in imageList" :key="image.CRC_DISPLAYID">
        <v-card class="mx-auto" max-width="344">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-img
                v-bind="attrs"
                v-on="on"
                style="cursor: pointer"
                @click="openLink(image.src)"
                alt="Click For Enlarge Image"
                :src="image.src"
                height="300px"
              >
              </v-img>
            </template>
            <span>Click For View Image in New Tab</span>
          </v-tooltip>

          <v-card-title class="text-center">
            <span v-if="image.DISPLAY_TYPE == 'VisibilityTATD'"
              >Team Ani Tampak Dekat</span
            >
            <span v-if="image.DISPLAY_TYPE == 'VisibilityTATJ'"
              >Team Ani Tampak Jauh</span
            >
            <span v-if="image.DISPLAY_TYPE == 'VisibilityTCTD'"
              >Team Combo Tampak Dekat</span
            >
            <span v-if="image.DISPLAY_TYPE == 'VisibilityTCTJ'"
              >Team Combo Tampak Jauh</span
            >
            <span v-if="image.DISPLAY_TYPE == 'VisibilityATD'">Acrylic Tampak Dekat</span>
            <span v-if="image.DISPLAY_TYPE == 'VisibilityATJ'">Acrylic Tampak Jauh</span>
            <span v-if="image.DISPLAY_TYPE == 'Visibility'">Visibility</span>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>


export default {
  name: "Test",
  props: ["imageList"],
  data() {
    return {
      SERVER: "",
    };
  },
  created() {
    if (this.$env == "DEV") {
      this.SERVER = "http://192.168.3.117:30903";
    } else if (this.$env == "UAT") {
      this.SERVER = "https://imaps.anugrah-argon.com";
    }
  },
  methods: {
    openLink(URL) {
      var image = new Image();
      image.src = URL;

      var w = window.open("");
      w.document.write(image.outerHTML);
    },
  },
};
</script>
